/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Body from "../../components/Body";
import Tab from "../../components/Tab";
import useHeader from "../../hooks/useHeader";
import InvoiceToBeSent from "./InvoiceToBeSent";
import api from "../../config/api";
import ContractGeneratedInvoices from "./ContractGeneratedInvoices";
import moment from "moment";
import { observer } from "mobx-react-lite";
import { orderBy } from "lodash";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getContractInvocies } from "../../stores/ContractInvocieStore";
import { getContracts, getInvoices } from "../../stores/ContractStore";

function ContractInvoices() {
  const { setHeader } = useHeader();
  const [toBeSent, setToBeSent] = useState();

  useEffect(() => {
    setHeader("Contract Invoices");
  }, []);

  const { data: contracts } = useQuery({
    queryFn: () => getContracts(),
    queryKey: ["contracts"],
  });

  const { data: invoices } = useQuery({
    queryFn: () => getContractInvocies(),
    queryKey: ["contractInvoice"],
  });

  useEffect(() => {
    if (contracts?.length > 0) {
      setToBeSent(getInvoices({ contracts }));
    }
  }, [contracts]);

  const filteredTobeSend =
    (invoices &&
      toBeSent &&
      toBeSent?.filter((tobe) => {
        const today = moment();
        if (moment(tobe.startDate).valueOf() > moment(today).valueOf()) {
          return false;
        }

        const found = invoices?.find((i) => {
          return (
            i.contract?.contractId === tobe.contract?.contractId &&
            moment(i.startDate).format("YYYY-MM") ===
              moment(tobe.startDate).format("YYYY-MM")
          );
        });
        return !found;
      })) ||
    [];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 20,
      }}
    >
      <div style={{ width: "90%" }}>
        <InvoiceToBeSent list={filteredTobeSend} />
      </div>
    </div>
  );
}
export default observer(ContractInvoices);
